export const extractDomainFromInfo = (info: {
  displayUrl: string | undefined;
  loginUrl: string | undefined;
}) => {
  // Prioritize displayUrl (e.g., "aetna.com") over loginUrl (e.g., "health.aetna.com")
  // since main domains work better with Google's favicon service
  if (info.displayUrl) {
    // displayUrls are not always URLs, strictly speaking, so we just strip
    // the protocol instead of parsing them like we do with loginUrls.
    return info.displayUrl.replace(/^https?:\/\//, "");
  }
  if ("loginUrl" in info && info.loginUrl) {
    const hostname = new URL(info.loginUrl).hostname;
    return hostname;
  }
};

export const getFaviconUrl = (domain: string) => {
  return `https://www.google.com/s2/favicons?domain=${domain}&sz=32`;
};
